import { render, staticRenderFns } from "./TgMobileGameList.vue?vue&type=template&id=140e566c&"
import script from "./TgMobileGameList.vue?vue&type=script&lang=js&"
export * from "./TgMobileGameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports